import { CardMetadata } from '../hosted-scripts/CardMetadata';
import CheckoutStore from '../store/CheckoutStore';

interface CardMetaChangeHandler {
  (meta: CardMetadata): void;
}

export function cardTypeChangeHandler(
  store: CheckoutStore,
): CardMetaChangeHandler {
  return (meta) => {
    store.setCardMetadata(meta);
  };
}
